export const environment = {
  production: false,
  clientName: 'siesa',
  apiGatewayFront: 'https://adminagr.plexa.co/',
  apiGatewayBackOffice: 'https://adminagr.plexa.co/',
  apiUrl: 'https://adminagr.plexa.co/',
  urlPath: 'https://adminagr.plexa.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  siteKeyCaptcha: '6LdiXWMpAAAAAOWGcI-P0iHeMwTF4E7duPQlWg1m',
  googleAnalyticsCode: 'UA-140785247-1',

 

};


